<template>
  <transition name="fade">
    <div class="limited-time-select-role-popup" v-if="visible">
      <div class="role-popup">
        <p class="dialog-title">{{ letter.limitedTimeActivityClaimAward }}</p>
        <div class="select-group">
          <SelectGroup
            icon="selectvh"
            rightSpan="53px"
            class="row-item mb15"
            v-model="serverId"
            @change="selectServer"
          >
            <template slot="option">
              <option value="0" disabled>
                {{ letter.creatework_serverHolder }}
              </option>
              <optgroup :label="letter.yourServer">
                <option
                  v-for="item in historyServerList"
                  :key="item.ID"
                  :value="item.ID"
                >
                  {{ item.NAME }}
                </option>
              </optgroup>
              <optgroup :label="letter.allServer">
                <option
                  v-for="item in serverList"
                  :key="item.ID"
                  :value="item.ID"
                >
                  {{ item.NAME }}
                </option>
              </optgroup>
            </template>
            <template slot="ico">
              <em class="ico"></em>
            </template>
          </SelectGroup>
          <Select
            v-if="roleList && roleList.length !== 0"
            icon="selectvh"
            rightSpan="53px"
            class="row-item role-select mb15"
            v-model="roleId"
          >
            <template slot="option">
              <option value="-1" disabled>
                {{ letter.selectRoleName }}
              </option>
              <option
                v-for="item in roleList"
                :key="item.roleID"
                :value="item.roleID"
              >
                {{ item.roleName }}
              </option>
            </template>
            <template slot="ico">
              <em class="ico"></em>
            </template>
          </Select>
          <Select
            v-else
            icon="selectvh"
            rightSpan="53px"
            class="row-item mb15"
            v-model="roleId"
          >
            <template slot="option">
              <option value="-1" disabled v-if="!serverId">
                {{ letter.selectRoleName }}
              </option>
              <option value="-1" disabled v-else>
                {{ letter.creatework_noRole }}
              </option>
            </template>
            <template slot="ico">
              <em class="ico"></em>
            </template>
          </Select>
        </div>
        <Button class="confirm-btn" @click="confirm">{{
          letter.limitedTimeActivityConfirmGot
        }}</Button>
        <Button class="close-btn" @click="hidePopup"></Button>
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import { GET_ROLE_LIST_ONLY } from '@store/officialStore';
import { clickButton, locationType } from '@plugins/biPoint/_configWebstoreV1';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
export default {
  name: 'limitedTimeAwardDeatailPopup',
  props: ['visible'],
  data() {
    return {
      serverId: 0,
      roleId: '-1',
      roleList: [],
      isRoleChange: false
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      letter: state => state.letter,
      stateServerId: state => state.serverId,
      stateRoleId: state => state.roleId,
      serverList: state => state.serverList,
      historyServerList: state => state.historyServerList,
      stateRoleList: state => state.roleList
    }),
    chooseServer() {
      return this.serverList.find(item => item.ID == this.serverId);
    },
    chooseRole() {
      return this.roleList.find(item => item.roleID == this.roleId);
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // 默认给当前角色
        this.serverId = this.stateServerId || 0;
        this.roleList = this.stateRoleList || [];
        this.roleId = this.stateRoleId || '-1';
      }
    },
    roleId() {
      if (this.roleId && this.roleId !== '-1') {
        if (this.isRoleChange) {
          // 打点打的是当前选择的区服和角色
          window.webstorev1DataLayer.push({
            eventName: 'click_button',
            eventType: 'switch_role',
            eventReason: locationType.confirmRolePopup,
            serverId: this.chooseServer.ID,
            roleId: this.chooseRole.roleID,
            roleName: this.chooseRole.roleName,
            ...getGlobalGetLinkParams({ acitivtyId: '2234' })
          });
        }
        this.isRoleChange = true;
      }
    }
  },
  methods: {
    selectServer() {
      this.roleId = '';
      this.$store.dispatch(GET_ROLE_LIST_ONLY, this.serverId).then(roleList => {
        this.roleList = roleList;
        if (this.roleList.length > 0) {
          this.roleId = this.roleList[0].roleID;
        } else {
          this.roleId = '-1';
        }
      });
    },
    hidePopup() {
      this.$emit('onCancle');
    },
    confirm() {
      if (this.serverId && this.roleId) {
        this.$emit('onConfirm', {
          server_id: this.chooseServer.SID,
          server_sid: this.serverId,
          server_name: this.chooseServer.NAME,
          role_id: this.roleId,
          role_name: this.chooseRole.roleName
        });
        clickButton({
          btnName: 'confirm_role',
          locationKey: locationType.confirmRolePopup
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.limited-time-select-role-popup {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 101;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);

  .role-popup {
    position: relative;
    background-size: 100% 100%;
    @psetbg ('common-popup.png');
    text-align: center;

    .select-group {
      display: inline-block;
      width: 100%;
      margin: 30px 0;

      .row-item {
        display: block;
        position: relative;
        box-sizing: border-box;
        margin: 0 auto 23px;
        width: 100%;
        background-size: cover;
        font-size: 24px;
        color: var(--input-role);
        @psetbg ('role-choose.png');
        ::v-deep .select {
          color: var(--input-role) !important;
        }
        &.mb15 {
          margin-bottom: 15px;
        }
      }
      .ico {
        display: inline-block;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        @psetbg ('role-ico.png');
      }
    }
    .confirm-btn {
      font-size: 30px;
      color: var(--input-role);
      background-size: cover;
      @psetbg ('confirm.png');
    }
    .close-btn {
      position: absolute;
      @psetbg ('close.png');
    }
  }
}
</style>
